const config = require('~/config')
const { languages, currencies, initials } = config

export default {
  namespaced: true,
  state: () => ({
    locale: initials.locale,
    languages: languages,
    currency: initials.currency.toUpperCase(),
    currencies: currencies,
  }),
  getters: {
    locale: (state) => state.locale,
    languages: (state) => state.languages,
    currency: (state) => state.currency,
    currencies: (state) => state.currencies,
  },
  actions: {
    setLang: ({ commit }, lang) => {
      commit('SET_LANG', lang)
    },
    setCurr: ({ commit }, curr) => {
      commit('SET_CURR', curr)
    },
  },
  mutations: {
    SET_LANG(state, lang) {
      state.locale = lang
    },
    SET_CURR(state, curr) {
      state.currency = curr
    },
  },
}
